export function throttle(timeMs, func, opts) {
  let isCoolDown = false;
  if (!opts?.leadingEdge) {
    isCoolDown = true;
    setTimeout(() => {
      isCoolDown = false;
    }, timeMs);
  }
  return function(...args) {
    if (isCoolDown)
      return;
    isCoolDown = true;
    func(...args);
    setTimeout(() => {
      isCoolDown = false;
    }, timeMs);
  };
}
